import Vue from "vue";

Vue.component("SkeletonBox", () =>
  import("./components/shared/ProductSkeleton.vue")
);
